import React, { useEffect, useState } from 'react';

import './index.scss';
import { Select as MatSelect, FormControl, InputLabel, MenuItem, OutlinedInput } from '@mui/material';
import Icon from "../../stateless/Icon";


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Select = ({ slug, hasError, name, list = [], flags = false, multiple = false, selected = '', onChange, reset }) => {
  const [value, setValue] = useState(selected ? flags ? selected.phoneCode[0] : selected : multiple ? [] : '');

  const selectAndClose = (e) => {
    const val = e.target.value;

    if (slug === 'company.countryCode') {
      setValue(val);
      onChange(val.code);
    } else if (multiple) {
      setValue(typeof val === 'string' ? val.split(',') : val);
      onChange(typeof val === 'string' ? val.split(',') : val);
    } else {
      setValue(val);
      onChange(val);
    }
  };

  useEffect(() => {
    reset && setValue(multiple ? [] : flags ? selected.phoneCode[0] : '');
  }, [reset, list, selected]);

  return (
    <div className="select-wrapper">
    <FormControl fullWidth>
      <InputLabel id="demo-multiple-name-label">{name}</InputLabel>
      <MatSelect
        labelId="demo-multiple-name-label"
        className="capitalize"
        multiple={multiple}
        error={hasError}
        onChange={selectAndClose}
        value={value}
        input={<OutlinedInput label={name} />}
        MenuProps={MenuProps}
      >
        {list.map((item, index) => (
          <MenuItem
            key={flags ? `${item.phoneCode[0]}${index}` : `${item}${index}`}
            value={flags ? item.phoneCode[0] : slug === 'company.countryCode' ? item : item.value}
            className="capitalize"
          >
            {
              flags
                ? <><i className={`flag flag-${item.name.trim().toLowerCase()}`}/><span>{item.phoneCode[0]}</span></>
                : item.name
            }
          </MenuItem>
        ))}
      </MatSelect>
      <Icon icon="vector-icon" />
    </FormControl>
    </div>
  );
};

export default Select;
